import {
  Flex,
  Avatar,
  Text,
  Box,
  Icon,
  HStack,
  VStack,
  Spinner,
  IconButton,
  Badge,
} from "@chakra-ui/react";
import { FaBell } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { useEffect, useState } from "react";
import NotificationDrawer from "../Customer-dashboard/NotificationDrawer";
import axiosInstance from "../../config/axiosInstance";

const Header = ({ onSidebarOpen }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isNotifOpen, setNotifOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  // Fetch logged-in user
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axiosInstance.get("/api/users/me");
        setUser(res.data);
      } catch (err) {
        console.error("Failed to fetch user", err);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  // Fetch unread notifications for header instantly and poll
  useEffect(() => {
    if (!user) return;

    const fetchUnreadCount = async () => {
      try {
        const res = await axiosInstance.get("/api/notifications");
        if (res.data.success) {
          const unread = (res.data.notifications || []).filter((n) => !n.isRead)
            .length;
          setUnreadCount(unread);
        }
      } catch (err) {
        console.error("Failed to fetch notifications", err);
      }
    };

    fetchUnreadCount(); // fetch immediately

    const interval = setInterval(fetchUnreadCount, 10000); // every 10 sec
    return () => clearInterval(interval); // cleanup
  }, [user]);

  return (
    <>
      <Box
        bg="white"
        borderBottom="1px solid #e2e8f0"
        px={4}
        py={4}
        boxShadow="sm"
        position="sticky"
        top={0}
        zIndex={999}
      >
        <Flex justify="space-between" align="center">
          <Box display={{ base: "block", md: "none" }}>
            <IconButton
              icon={<FiMenu />}
              variant="ghost"
              aria-label="Open Menu"
              onClick={onSidebarOpen}
            />
          </Box>

          <Box ml="auto">
            {loading ? (
              <Spinner size="sm" />
            ) : (
              <HStack spacing={4} align="center">
                <Box position="relative">
                  <Icon
                    as={FaBell}
                    color="gray.600"
                    boxSize={5}
                    cursor="pointer"
                    onClick={() => setNotifOpen(true)}
                  />
                  {unreadCount > 0 && (
                    <Badge
                      position="absolute"
                      top="-2px"
                      right="-2px"
                      colorScheme="red"
                      borderRadius="full"
                      fontSize="0.7em"
                    >
                      {unreadCount}
                    </Badge>
                  )}
                </Box>
                <Avatar size="sm" name={user?.name || "User"} />
                <VStack spacing={0} align="start">
                  <Text fontSize="sm" fontWeight="medium">
                    {user?.name || "User"}
                  </Text>
                  <Text fontSize="xs" color="gray.500">
                    {user?.role || "Role"}
                  </Text>
                </VStack>
              </HStack>
            )}
          </Box>
        </Flex>
      </Box>

      <NotificationDrawer
        isOpen={isNotifOpen}
        onClose={() => setNotifOpen(false)}
        setUnreadCount={setUnreadCount}
      />
    </>
  );
};

export default Header;
